export const DOMAIN = "/api/"; 
// export const DOMAIN = "http://localhost:8000/";

export const AppKey = "W3L3A";